// Meta tag e contenuti SEO aggiuntivi per EscortFun.net
import { SITE_URL, DOMAIN, TITLE, BRAND_SHORT } from '../config/domain';

export interface SEOMetaTags {
  title: string;
  description: string;
  keywords: string;
  openGraph: {
    title: string;
    description: string;
    type: string;
    image?: string;
    url?: string;
    siteName: string;
  };
  twitter: {
    card: string;
    title: string;
    description: string;
    image?: string;
  };
  structuredData: any;
}

// Meta tag globali per il sito
export const globalSEOTags: SEOMetaTags = {
  title: `${TITLE} - Le Migliori Escort d'Italia | Directory Escort Premium`,
  description: `${TITLE} è la directory escort più completa d'Italia. Trova escort verificate, accompagnatrici di lusso e servizi premium in tutte le città italiane. Annunci escort autentici e sicuri.`,
  keywords: `escort italia, accompagnatrici italia, escort directory, escort verificate, escort premium, escort di lusso, escort vip, escort annunci, escort sicure, escort professionali, escort online, escort sito, escort website, escort forum, escort recensioni, ${BRAND_SHORT}, escort girls italia, escort donne italia, escort modelle italia, escort hostess italia, escort per eventi, escort per cene, escort business, escort 24h, escort disponibili, escort contatti, escort telefono, escort whatsapp, escort telegram`,
  openGraph: {
    title: `${TITLE} - Directory Escort Premium Italia`,
    description: "Le migliori escort d'Italia in un'unica directory. Accompagnatrici verificate e servizi di lusso.",
    type: "website",
    siteName: TITLE,
    image: "/images/og-image.jpg"
  },
  twitter: {
    card: "summary_large_image",
    title: `${TITLE} - Escort Premium Italia`,
    description: "Directory escort verificate e accompagnatrici di lusso in tutta Italia."
  },
  structuredData: {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": TITLE,
    "description": "Directory escort premium italiana con accompagnatrici verificate",
    "url": SITE_URL,
    "sameAs": [
      `https://www.facebook.com/${BRAND_SHORT}`,
      `https://www.instagram.com/${BRAND_SHORT}`,
      `https://twitter.com/${BRAND_SHORT}`
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "email": `info@${DOMAIN}`
    },
    "areaServed": "IT",
    "serviceType": "Directory Service"
  }
};

// Schema strutturati per le pagine escort
export const createEscortProfileSchema = (escort: any) => ({
  "@context": "https://schema.org",
  "@type": "Person",
  "name": escort.name,
  "description": `Escort ${escort.city} - ${escort.description}`,
  "image": escort.photos[0],
  "address": {
    "@type": "PostalAddress",
    "addressLocality": escort.city,
    "addressRegion": escort.region,
    "addressCountry": "IT"
  },
  "offers": {
    "@type": "Offer",
    "description": "Servizi escort professionali",
    "areaServed": escort.city
  }
});

// Meta tag per pagine di città
export const createCityMetaTags = (cityName: string, regionName: string): SEOMetaTags => ({
  title: `Escort ${cityName} - Accompagnatrici di Lusso e Premium | ${TITLE}`,
  description: `Trova le migliori escort di ${cityName}, ${regionName}. Accompagnatrici verificate, escort di lusso e servizi premium. Annunci escort autentici e sicuri su ${TITLE}.`,
  keywords: `escort ${cityName.toLowerCase()}, accompagnatrici ${cityName.toLowerCase()}, escort ${regionName.toLowerCase()}, escort di lusso ${cityName.toLowerCase()}, escort premium ${cityName.toLowerCase()}, escort vip ${cityName.toLowerCase()}, escort verificate ${cityName.toLowerCase()}, annunci escort ${cityName.toLowerCase()}, escort professionali ${cityName.toLowerCase()}, escort indipendenti ${cityName.toLowerCase()}, escort belle ${cityName.toLowerCase()}, escort giovani ${cityName.toLowerCase()}, escort mature ${cityName.toLowerCase()}, escort italiane ${cityName.toLowerCase()}, escort straniere ${cityName.toLowerCase()}, escort bionde ${cityName.toLowerCase()}, escort brune ${cityName.toLowerCase()}, escort russe ${cityName.toLowerCase()}, escort brasiliane ${cityName.toLowerCase()}, escort girls ${cityName.toLowerCase()}, escort donne ${cityName.toLowerCase()}, escort ragazze ${cityName.toLowerCase()}, escort modelle ${cityName.toLowerCase()}, escort hostess ${cityName.toLowerCase()}, escort per eventi ${cityName.toLowerCase()}, escort per cene ${cityName.toLowerCase()}, escort per viaggi ${cityName.toLowerCase()}, escort business ${cityName.toLowerCase()}, escort 24h ${cityName.toLowerCase()}, escort notturne ${cityName.toLowerCase()}, escort weekend ${cityName.toLowerCase()}, escort disponibili ${cityName.toLowerCase()}, escort online ${cityName.toLowerCase()}, escort sito ${cityName.toLowerCase()}, escort directory ${cityName.toLowerCase()}, escort annunci ${cityName.toLowerCase()}, escort forum ${cityName.toLowerCase()}, escort recensioni ${cityName.toLowerCase()}, escort contatti ${cityName.toLowerCase()}, escort telefono ${cityName.toLowerCase()}, escort whatsapp ${cityName.toLowerCase()}, escort telegram ${cityName.toLowerCase()}, escort massage ${cityName.toLowerCase()}, escort relax ${cityName.toLowerCase()}, escort benessere ${cityName.toLowerCase()}, ${cityName.toLowerCase()} escort, ${BRAND_SHORT} ${cityName.toLowerCase()}`,
  openGraph: {
    title: `Escort ${cityName} - Le Migliori Accompagnatrici | ${TITLE}`,
    description: `Scopri le escort più belle ed eleganti di ${cityName}. Accompagnatrici professionali e servizi di lusso.`,
    type: "website",
    siteName: TITLE
  },
  twitter: {
    card: "summary_large_image",
    title: `Escort ${cityName} - Accompagnatrici Premium`,
    description: `Le migliori escort di ${cityName} su ${TITLE}. Servizi verificati e professionali.`
  },
  structuredData: {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": `Escort ${cityName} - ${TITLE}`,
    "description": `Directory escort di ${cityName} con accompagnatrici verificate`,
    "address": {
      "@type": "PostalAddress",
      "addressLocality": cityName,
      "addressRegion": regionName,
      "addressCountry": "IT"
    },
    "areaServed": cityName,
    "serviceType": "Escort Services Directory"
  }
});

// Contenuti FAQ per migliorare il SEO
export const escortFAQ = [
  {
    question: `Come funziona ${TITLE}?`,
    answer: `${TITLE} è una directory premium che raccoglie i migliori annunci escort d'Italia. Tutte le escort presenti sono verificate e offrono servizi professionali di accompagnatrici.`
  },
  {
    question: "Le escort sono verificate?",
    answer: `Sì, tutte le escort presenti su ${TITLE} sono accuratamente verificate. Controlliamo l'autenticità dei profili e delle foto per garantire la massima sicurezza e affidabilità.`
  },
  {
    question: "In quali città sono disponibili le escort?",
    answer: "Le nostre escort sono disponibili in tutte le principali città italiane: Roma, Milano, Napoli, Torino, Firenze, Bologna, Venezia, Palermo, Bari, Catania e molte altre."
  },
  {
    question: "Che tipi di servizi offrono le escort?",
    answer: `Le escort su ${TITLE} offrono servizi di accompagnatrici professionali: accompagno per eventi, cene di gala, viaggi, eventi aziendali, e servizi di hostess per occasioni speciali.`
  },
  {
    question: "Come posso contattare una escort?",
    answer: "Ogni profilo escort include i contatti diretti: telefono, WhatsApp e Telegram. Le escort gestiscono personalmente le prenotazioni garantendo massima discrezione."
  },
  {
    question: `${TITLE} è sicuro?`,
    answer: `Assolutamente sì. ${TITLE} garantisce la massima sicurezza e privacy. Tutti i profili sono verificati e rispettiamo rigorosamente la privacy dei nostri utenti.`
  },
  {
    question: "Posso pubblicare un annuncio escort?",
    answer: `Sì, se sei una escort professionista puoi pubblicare il tuo annuncio su ${TITLE}. Offriamo pacchetti premium per massimizzare la visibilità del tuo profilo.`
  },
  {
    question: "Ci sono escort in tutte le fasce di prezzo?",
    answer: `Su ${TITLE} trovi escort per ogni budget: dalle accompagnatrici premium alle escort VIP di lusso. Ogni escort indica chiaramente le proprie tariffe.`
  }
];

// Schema FAQ strutturato per Google
export const faqStructuredData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": escortFAQ.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
};

// Breadcrumb schema per la navigazione
export const createBreadcrumbSchema = (items: Array<{name: string, url: string}>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

// Rich snippets per recensioni
export const createReviewSchema = (escort: any, reviews: any[]) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": `Escort ${escort.name} - ${escort.city}`,
  "description": escort.description,
  "provider": {
    "@type": "Person",
    "name": escort.name
  },
  "areaServed": escort.city,
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length,
    "reviewCount": reviews.length,
    "bestRating": 5,
    "worstRating": 1
  },
  "review": reviews.map(review => ({
    "@type": "Review",
    "author": {
      "@type": "Person",
      "name": review.author
    },
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": review.rating,
      "bestRating": 5,
      "worstRating": 1
    },
    "reviewBody": review.text,
    "datePublished": review.date
  }))
});

// Meta tag per pagine categoriche
export const createCategoryMetaTags = (category: string): SEOMetaTags => ({
  title: `${category} - Le Migliori della Categoria | ${TITLE}`,
  description: `Trova le migliori escort della categoria ${category} su ${TITLE}. Accompagnatrici specializzate e servizi premium per ogni esigenza.`,
  keywords: `escort ${category.toLowerCase()}, ${category.toLowerCase()} escort, accompagnatrici ${category.toLowerCase()}, escort specializzate, escort categoria, escort premium ${category.toLowerCase()}, escort vip ${category.toLowerCase()}, escort professionali ${category.toLowerCase()}`,
  openGraph: {
    title: `${category} Escort - Servizi Specializzati | ${TITLE}`,
    description: `Le migliori escort specializzate in ${category}. Servizi professionali e di qualità.`,
    type: "website",
    siteName: TITLE
  },
  twitter: {
    card: "summary_large_image",
    title: `${category} Escort Premium`,
    description: `Escort specializzate in ${category} su ${TITLE}`
  },
  structuredData: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": `Escort ${category}`,
    "description": `Servizi escort specializzati in ${category}`,
    "serviceType": `${category} Escort Services`,
    "provider": {
      "@type": "Organization",
      "name": TITLE
    }
  }
});

// Utility per generare meta tag dinamici
export const generateMetaTags = (type: 'city' | 'category' | 'profile', data: any): SEOMetaTags => {
  switch (type) {
    case 'city':
      return createCityMetaTags(data.cityName, data.regionName);
    case 'category':
      return createCategoryMetaTags(data.category);
    case 'profile':
      return {
        title: `Escort ${data.name} ${data.city} - Accompagnatrice Premium | ${TITLE}`,
        description: `${data.name}, escort professionale di ${data.city}. ${data.description} Contatti verificati su ${TITLE}.`,
        keywords: `escort ${data.name.toLowerCase()}, ${data.name.toLowerCase()} escort, escort ${data.city.toLowerCase()}, accompagnatrici ${data.city.toLowerCase()}, escort premium ${data.city.toLowerCase()}`,
        openGraph: {
          title: `Escort ${data.name} - ${data.city}`,
          description: data.description,
          type: "profile",
          siteName: TITLE,
          image: data.photos[0]
        },
        twitter: {
          card: "summary_large_image",
          title: `Escort ${data.name} - ${data.city}`,
          description: data.description,
          image: data.photos[0]
        },
        structuredData: createEscortProfileSchema(data)
      };
    default:
      return globalSEOTags;
  }
};
